import React, { FC, Suspense, lazy } from "react";
import { MainCover6Type, MainCover5Type } from "./main-cover.types";
import {
  WidgetProps,
  CoverWidgetConfig,
  BasicCoverProps,
  WidgetType,
} from "@commons-monorepo/index";
import { useInView } from "react-intersection-observer";
import { ContentCoverContext } from "./main-cover.context";

const MainCover1 = lazy(() => import("./skins/main-cover-1/main-cover-1"));
const MainCover2 = lazy(() => import("./skins/main-cover-2/main-cover-2"));
const MainCover3 = lazy(() => import("./skins/main-cover-3/main-cover-3"));
const MainCover4 = lazy(() => import("./skins/main-cover-4/main-cover-4"));
const MainCover5 = lazy(() => import("./skins/main-cover-5/main-cover-5"));

const MainCover: FC<WidgetProps<BasicCoverProps, CoverWidgetConfig>> = ({
  theme,
  storeMetadata,
  config,
  data,
  type,
}) => {
  const { Provider } = ContentCoverContext;
  const {
    stepToPause,
    isMobile,
    hasOffers,
    hasWholesale,
    setStoreInformationInView,
  } = data;

  const { ref } = useInView({
    threshold: 0.1,
    initialInView: true,
    onChange: (inView: boolean) => {
      setStoreInformationInView(inView);
    },
  });

  const providerValue = {
    config,
    theme,
    setStoreInformationInView,
    isMobile,
    stepToPause,
    storeMetadata,
    hasOffers,
    hasWholesale,
  };

  return (
    <Provider value={providerValue}>
      <div ref={ref} id='cover'>
        <Suspense>
          {type === WidgetType.COVER_1 && <MainCover1 />}
          {type === WidgetType.COVER_2 && <MainCover2 />}
          {type === WidgetType.COVER_3 && (
            <MainCover3 classTypeName={MainCover6Type.circles} />
          )}
          {type === WidgetType.COVER_4 && <MainCover4 />}
          {type === WidgetType.COVER_5 && (
            <MainCover5 classType={MainCover5Type.full} />
          )}
          {type === WidgetType.COVER_6 && (
            <MainCover3 classTypeName={MainCover6Type.lines} />
          )}
          {type === WidgetType.COVER_7 && (
            <MainCover5 classType={MainCover5Type.medium} />
          )}
        </Suspense>
      </div>
      <div id='scroll-to-element' />
    </Provider>
  );
};

export default MainCover;
